import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCilTl0dDYnSgzy29JLmkLF857SH-WWEx0",
  authDomain: "dc-luxury.firebaseapp.com",
  databaseURL: "https://dc-luxury-default-rtdb.firebaseio.com",
  projectId: "dc-luxury",
  storageBucket: "dc-luxury.appspot.com",
  messagingSenderId: "933600395201",
  appId: "1:933600395201:web:2df1f2371849fe09acb940",
  measurementId: "G-FW6YZ92PMJ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
